import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { loadersBuilder, errorBuilder, logoutBuilder } from '@modules/builders';
import { buyActions } from '@modules/buy';

import cardsActions from './actions';
import initialState from './state';
import type * as CardsTypes from './types';

const start3DSFlow = (state, action) => {
  if (action.payload.data.redirect) {
    state.card3DS.redirect = action.payload.data.redirect;
    state.bindId = action.payload.data.id;
  }
};

export const cardsReducer = createReducer(initialState, builder => {
  builder.addCase(cardsActions.resetBindCardState, state => {
    state.card3DS = {};
    delete state.bindStatus;
    delete state.bindId;
  });

  builder.addCase(cardsActions.clearRedirect, state => {
    state.card3DS.redirect = undefined;
  });

  builder.addCase(cardsActions.clearError, (state, action) => {
    delete state.errors.data?.[action.payload];
  });

  builder.addCase(cardsActions.clearAllErrors, state => {
    state.errors = {};
  });

  builder.addCase(cardsActions.resetCardData, state => {
    state.card = initialState.card;
    delete state.cardId;
  });

  builder.addCase(cardsActions.set3DSPassed, (state, action) => {
    state.card3DS.passed = action.payload;
  });

  builder.addCase(cardsActions.setCardId, (state, action) => {
    state.cardId = action.payload;
  });

  builder.addCase(cardsActions.getCards.fulfilled, (state, action) => {
    state.list = action.payload.data.filter(el => !el.issued_by_mercuryo);
  });

  builder.addCase(cardsActions.bind.fulfilled, (state, action) => {
    start3DSFlow(state, action);
    if (!action.payload.data.redirect) {
      state.bindStatus = action.payload.data.status;
      state.bindId = action.payload.data.id;
    }
  });

  builder.addCase(cardsActions.deleteCard.fulfilled, (state, action) => {
    if (state.list?.length) {
      state.list = state.list.filter(el => el.id !== action.meta.arg.id);
    }
    delete state.cardId;
  });

  builder.addCase(cardsActions.setCard, (state, action) => {
    const { name, value } = action.payload;
    state.card[name] = value;
  });

  builder.addCase(cardsActions.flutterwaveValidate.fulfilled, start3DSFlow);

  builder.addCase(buyActions.buyRequest.fulfilled, start3DSFlow);

  builder.addCase(buyActions.buyRecheck.fulfilled, start3DSFlow);

  builder.addMatcher(
    isAnyOf(cardsActions.getBindStatus.fulfilled, cardsActions.getBindStatusPolling.fulfilled),
    (state, action) => {
      state.bindStatus = action.payload.data.status;
    }
  );

  loadersBuilder('cards', builder);
  logoutBuilder(initialState, builder);
  errorBuilder('cards', builder);
});

export { cardsActions, CardsTypes };
